'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierRegistration', cobCarrierRegistration);

	cobCarrierRegistration.$inject = [
		'$state', 'subjectObserverMessagesService', 'observerService', 'carrierRegistrationService',
		'authenticationService', 'sessionService', 'validationService', 'spinnerService'
	];

	var $state,
		subjectMessages,
		observerMessages,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		authenticationService,
		sessionService,
		spinnerService,
		validationService;

	function cobCarrierRegistration(_$state_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_authenticationService_,
		_sessionService_,
		_validationService_,
		_spinnerService_) {
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		authenticationService = _authenticationService_;
		sessionService = _sessionService_;
		validationService = _validationService_;
		spinnerService = _spinnerService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/carrierRegistration.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			var carrier = carrierRegistrationService.getCarrier();

			if (Object.keys(carrier).length === 0) {
				$state.go('dot');

				return;
			}

			scope.m = {
				carrier: carrier,
				firstName: '',
				lastName: '',
				jobTitle: '',
				phoneNumber: '',
				phoneExtension: '',
				emailAddress: '',
				password1: '',
				password2: '',
				firstNameError: '',
				lastNameError: '',
				phoneNumberError: '',
				jobTitleError: '',
				emailAddressError: '',
				password1Error: '',
				password2Error: '',
				isAccountCreatedSuccess: false,

				errors: []
			};

			scope.submitForm = submitForm;
			scope.validateFirstNameField = validateFirstNameField;
			scope.validateLastNameField = validateLastNameField;
			scope.validateJobTitleField = validateJobTitleField;
			scope.validatePhoneNumberField = validatePhoneNumberField;
			scope.validateEmailAddressField = validateEmailAddressField;
			scope.validatePassword1 = validatePassword1;
			scope.validatePasswords = validatePasswords;
			scope.getIntrastateLabel = getIntrastateLabel;

			registerObserverHandlers();
			document.title = 'Carrier Registration';

		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_LOGIN_FINISHED_SUCCESS, handler: onLoginSuccess },
				]);
		}

		function submitForm() {
			validateForm();
		}

		function validateForm() {
			validateFirstNameField();
			validateLastNameField();
			validateJobTitleField();
			validatePhoneNumberField();
			validateEmailAddressField();
			validatePasswords();

			if (scope.m.firstNameError.length === 0 &&
                scope.m.lastNameError.length === 0 &&
                scope.m.phoneNumberError.length === 0 &&
                scope.m.emailAddressError.length === 0 &&
                scope.m.jobTitleError.length === 0 &&
                scope.m.password1Error.length === 0 &&
                scope.m.password2Error.length === 0) {

				spinnerService.startSpinner(scope);

				carrierRegistrationService.registerCarrier(scope.m.carrier.tCoreId,
					scope.m.firstName,
					scope.m.lastName,
					scope.m.jobTitle,
					scope.m.phoneNumber,
					scope.m.phoneExtension,
					scope.m.emailAddress,
					scope.m.password1)
					.then(function(response) {
						if (!response.data.accountAlreadyExists) {
							scope.m.isAccountCreatedSuccess = true;
						} else {
							scope.m.emailAddressError = 'The email address entered is already associated ' +
                                'with an existing DAT OnBoard account. Please enter a different email address to proceed.';
						}
					})
					.finally(function() {
						spinnerService.stopSpinner(scope);
					});
			}

		}

		function validateFirstNameField() {
			if (scope.m.firstName.length === 0) {
				scope.m.firstNameError = 'Input is required';

				return false;
			}

			scope.m.firstNameError = '';

			return scope.m.firstNameError.length === 0;
		}

		function validateLastNameField() {
			if (scope.m.lastName.length === 0) {
				scope.m.lastNameError = 'Input is required';

				return false;
			}

			scope.m.lastNameError = '';

			return scope.m.lastNameError.length === 0;
		}

		function validateJobTitleField() {
			if (scope.m.jobTitle.length === 0) {
				scope.m.jobTitleError = 'Input is required';

				return false;
			}

			scope.m.jobTitleError = '';

			return scope.m.jobTitleError.length === 0;
		}

		function validatePhoneNumberField() {
			if (scope.m.phoneNumber.length === 0) {
				scope.m.phoneNumberError = 'Input is required';

				return false;
			}

			if (scope.m.phoneNumber.length !== 10) {
				scope.m.phoneNumberError = 'Valid input is required';

				return false;
			}

			if (scope.m.phoneNumber[0] === '0' || scope.m.phoneNumber[0] === '1') {
				scope.m.phoneNumberError = 'Valid input is required';

				return false;
			}

			scope.m.phoneNumberError = '';

			return scope.m.phoneNumberError.length === 0;
		}

		function validateEmailAddressField() {
			if (scope.m.emailAddress.length === 0) {
				scope.m.emailAddressError = 'Input is required';

				return false;
			}

			if (!validationService.isValidEmail(scope.m.emailAddress)) {
				scope.m.emailAddressError = 'Valid email is required';

				return false;
			}

			scope.m.emailAddressError = '';

			return scope.m.emailAddressError.length === 0;
		}

		function validatePassword1() {
			if (scope.m.password1.length === 0) {
				scope.m.password1Error = 'Input is required';
			} else {
				scope.m.password1Error = '';
			}

			if (scope.m.password1.length > 0) {
				if (!validationService.isValidPassword(scope.m.password1)) {
					scope.m.password1Error = 'Password requirements were not met.';
				} else {
					scope.m.password1Error = '';
				}
			}
		}

		function validatePasswords() {
			if (scope.m.password1.length === 0) {
				scope.m.password1Error = 'Input is required';
			} else {
				scope.m.password1Error = '';
			}

			if (scope.m.password2.length === 0) {
				scope.m.password2Error = 'Input is required';
			} else {
				scope.m.password2Error = '';
			}

			if (scope.m.password1.length > 0) {
				if (!validationService.isValidPassword(scope.m.password1)) {
					scope.m.password1Error = 'Password requirements were not met.';
				} else {
					scope.m.password1Error = '';
				}
			}

			if (scope.m.password2.length > 0) {
				if (!validationService.isValidPassword(scope.m.password2)) {
					scope.m.password2Error = 'Password requirements were not met.';
				} else {
					scope.m.password2Error = '';
				}
			}

			if (scope.m.password1.length > 0 && scope.m.password2.length > 0) {
				if (scope.m.password1 !== scope.m.password2) {
					scope.m.password2Error = 'Passwords must match';
				} else {
					scope.m.password2Error = '';
				}
			}

			return scope.m.password1Error.length === 0 && scope.m.password2Error.length === 0;
		}

		function getIntrastateLabel() {
			if (scope.m.carrier.intrastateState === 'AB' ||
                scope.m.carrier.intrastateState === 'BC' ||
                scope.m.carrier.intrastateState === 'ON' ||
                scope.m.carrier.intrastateState === 'PQ' ||
                scope.m.carrier.intrastateState === 'MB' ||
                scope.m.carrier.intrastateState === 'NS' ||
                scope.m.carrier.intrastateState === 'NB' ||
                scope.m.carrier.intrastateState === 'PE' ||
                scope.m.carrier.intrastateState === 'SK' ||
                scope.m.carrier.intrastateState === 'NL' ||
                scope.m.carrier.intrastateState === 'NT' ||
                scope.m.carrier.intrastateState === 'YT' ||
                scope.m.carrier.intrastateState === 'NU') {
				return 'Canadian DAT ID Number: ';
			} else {
				return 'Intrastate Number: ';
			}
		}

		function onLoginSuccess() {
			sessionService.saveCarrierVisit();
			$state.go('carrierProfile.company.showModal');
		}
	}

})();
